<template>
	<p-dialog
		:visible='value'
		@update:visible='onInput'
		modal

		:header='title'
	>
		<div class="confirmation-content">
      <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
      <span>{{ message }}</span>
    </div>

    <template #footer>
        <p-button :label="rejectLabel" icon="pi pi-times" @click="closeConfirmation" class="p-button-text"/>
        <p-button :label="confirmLabel" icon="pi pi-check" @click="onConfirm" :class="confirmButtonClass" autofocus />
    </template>

	</p-dialog>
</template>

<script>
	export default {
		name: 'CustomPConfirmation',

		props: {
			value: Boolean,
			title: {
				type: String,
				default: 'Подтверждение'
			},

			message: {
				type: String,
				default: 'Вы уверены'
			},

			confirmLabel: {
				type: String,
				default: 'Да'
			},

			rejectLabel: {
				type: String,
				default: 'Нет'
			},

			confirmButtonClass: {
				type: String,
				default: 'p-button-text'
			}
		},

		methods: {
			onInput(event) {
				this.$emit('input', event);
			},

			closeConfirmation() {
				this.$emit('input', false);
			},

			onConfirm() {
				this.$emit('input', false);
				this.$emit('confirm');
			},
		}
	};
</script>

<style scoped>

	.confirmation-content {
		display: flex;
		align-items: center;
	}


</style>